const updates = [
  {
    date: '07-30',
    title: '《庆余年第二季》第29-30集上线',
    desc: '范闲身世之谜逐步揭晓，京都风云再起，剧情迎来重大转折。',
    tag: '新剧更新',
  },
  {
    date: '07-29',
    title: '棒棒TV平台播放线路升级完成',
    desc: '全面优化CDN节点分布，偏远地区播放流畅度提升40%。',
    tag: '平台公告',
  },
  {
    date: '07-28',
    title: '《流浪地球3》预告片独家上线',
    desc: '国产科幻再续新篇章，预告片48小时播放量突破500万。',
    tag: '独家内容',
  },
  {
    date: '07-27',
    title: '暑期档特别企划：每日一部经典',
    desc: '连续30天推荐一部高分电影，搭配深度影评解读。',
    tag: '专题活动',
  },
  {
    date: '07-26',
    title: '新增多语言字幕支持功能',
    desc: '热门剧集现已支持中英双语字幕切换，追剧学外语两不误。',
    tag: '功能升级',
  },
  {
    date: '07-25',
    title: '《大奉打更人》全集高清上线',
    desc: '王鹤棣主演古装探案喜剧，全集一次性放出，畅快追剧。',
    tag: '新剧上线',
  },
  {
    date: '07-24',
    title: '悬疑剧场专区正式开放',
    desc: '集中展示国内外高分悬疑剧集，烧脑爱好者一站式追剧。',
    tag: '新功能',
  },
  {
    date: '07-23',
    title: '棒棒TV日活跃用户突破500万',
    desc: '感谢每一位观众的支持与信任，我们将持续优化观影体验。',
    tag: '里程碑',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            最新动态
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-foreground-900">
            平台快讯与更新日志
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            第一时间了解棒棒TV的最新内容与功能变化
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((update, idx) => (
            <div
              key={idx}
              className="relative flex gap-4 md:gap-6 pb-6 md:pb-8 last:pb-0 group"
            >
              <div className="flex flex-col items-center">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-background-50 border border-background-200/70 text-xs font-heading font-bold text-foreground-600 group-hover:border-primary-300 group-hover:text-primary-500 transition-all duration-200 flex-shrink-0">
                  {update.date}
                </div>
                {idx < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-200/70 mt-2 group-hover:bg-primary-200 transition-colors"></div>
                )}
              </div>
              <div className="flex-1 min-w-0 pt-2">
                <div className="flex items-center gap-2 flex-wrap mb-1.5">
                  <span className="whitespace-nowrap px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                    {update.tag}
                  </span>
                </div>
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {update.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {update.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}